import { useMemo } from 'react';

import { useNavigate } from 'libs/navigation';

export const useGetNavigateSearchParams = <T extends string>(params: T[]) => {
  const { searchParams } = useNavigate();

  const result = useMemo(
    () =>
      params.reduce((acc, param) => {
        acc[param] = searchParams.get(param);
        return acc;
      }, {} as Record<T, string | null>),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...params, searchParams]
  );

  return result;
};
